import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Dialog,
  DialogActions,
  DialogContent
} from "@mui/material";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { useFormik } from "formik";
import * as R from "ramda";
import React, { useState, useMemo, useCallback } from "react";
import { PaperArrastavel } from "../../dialog-arrastavel/PaperArrastavel";
import globalMU from "../../../../globalMU";
import { InputNumerico } from "../../inputs/InputNumerico";

const estiloModalSimularDesconto = require("./modalSimularDesconto.module.scss").default;
const estiloFormulario = require('../../../estilos/formulario.module.scss').default;

export type DadosSimularDesconto = {
  PercentualDesconto?: number;
  PreservaDesconto?: boolean;
  PercentualBonificacao?: number;
  ValorNaoIncideDesconto?: number; //&& 458061_458098 PA447380
  Preco?: number;
  PrecoUnitarioTabela?: number;
  Transforming?: boolean;
  DescontoPendente?: boolean;
  PendenciaDescontoSobreOferta?: boolean;
  PercentualMaximoDesconto?: number; // 448892
};

export type ErroSimularDesconto = {
  PrecoProduto?: string;
  PercentualBonificacao?: string;
  PercentualDesconto?: string;
};

export type DadosSimularDescontoSaida = {
  PercentualDesconto: number;
  PercentualBonificacao: number;
  Preco: number;
  PreservaDesconto: boolean;
  PreservaDescontoModificadoManualmente: boolean;
};

export type ModalSimularDescontoProps = {
  item: IItemOrcamento;
  dadosSimularDesconto: DadosSimularDesconto;
  numeroCasasDecimaisPreco: number;
  permitirAlterarPrecoParaMaior: boolean; // 462697
  exibirDescontoMaximoBonificacaoAvancados: boolean;
  exibirCheckboxPreservarDesconto: boolean;
  descontoCalculado: boolean;
  somenteLeitura: boolean;
  onAplicar: () => void;
  onAumentarPreco: (valor: number) => void; // 462697
  onManterDadosAlteradoParaCalcular: () => void;
  onSimular: (dados: DadosSimularDescontoSaida) => void;
  onErrorValidacao: (erroSimularDesconto: ErroSimularDesconto) => void;
  onCancelar: () => void;
};

export const ModalSimularDesconto = (props: ModalSimularDescontoProps) => {
  const [validado, setValidado] = useState(false);
  const [preservaDescontoModificadoManualmente, setPreservaDescontoModificadoManualmente] = useState(false);

  const formik = useFormik({
    initialValues: {
      PercentualDesconto: props.dadosSimularDesconto.PercentualDesconto,
      PercentualBonificacao: props.dadosSimularDesconto.PercentualBonificacao,
      ValorNaoIncideDesconto: props.dadosSimularDesconto.ValorNaoIncideDesconto, //&& 458061_458098 PA447380
      PrecoProduto: props.dadosSimularDesconto.Preco,
      PreservaDesconto: props.dadosSimularDesconto.PreservaDesconto,
      PrecoUnitarioTabela: props.dadosSimularDesconto.PrecoUnitarioTabela // 433081 - 260814 e 278816s
    },
    onSubmit: () => {},
    enableReinitialize: true,
    validate: (values) => {
      return R.pickBy((val) => globalMU.isNotNullOrEmpty(val), {
        PrecoProduto:
          !props.permitirAlterarPrecoParaMaior && (values.PrecoProduto ?? 0 - (values.ValorNaoIncideDesconto ?? 0)) > values.PrecoUnitarioTabela // 433081 - 260814 e 278816
            ? "O campo 'Preço Final' não pode ser maior que o valor do produto"
            : values.PrecoProduto < 0
            ? "O campo 'Preço Final' não pode ser menor que 0"
            : undefined,
        PercentualBonificacao:
          values.PercentualBonificacao >= 100
            ? "O campo 'Bonificação' não pode ser maior que 99,99%"
            : undefined,
        PercentualDesconto:
          values.PercentualDesconto >= 100
            ? "O campo 'Desconto' não pode ser maior que 99,99%"
            : undefined,
      });
    },
  });

  const descricaoProduto = useMemo(() => (
    <>
      <label>Produto</label>
      <div className={estiloModalSimularDesconto?.produto} 
        id="ModalSimularDesconto_DescricaoProduto"
      >
        {props.item?.DescricaoProduto}
      </div>
    </>
  ), [props.item?.DescricaoProduto]);

  const precoDeLista = useMemo(() => (
    <>
      <label>Preço de Lista</label>
      <div id="ModalSimularDesconto_PrecoDeLista">
        {globalMU.formatarValorNumerico(props.dadosSimularDesconto?.PrecoUnitarioTabela, 2, true)}
      </div>
    </>
  ), [props.dadosSimularDesconto?.PrecoUnitarioTabela]);

  const percentualDescontoMaximo = useMemo(() => (
    <>
      <label id="ModalSimularDesconto_PercentualMaximoDesconto">Desconto Máximo (%)</label>
      <div id="ModalSimularDesconto_PercentualMaximoDesconto_valor">
        {globalMU.formatarValorNumerico(
          props.dadosSimularDesconto?.PercentualMaximoDesconto, // 448892
          2,
          false
        )}
      </div>
    </>
  ), [props.dadosSimularDesconto?.PercentualMaximoDesconto]);

  const percentualDesconto = useMemo(() => (
    <>
      <label id="ModalSimularDesconto_PercentualDesconto">Desconto (%)</label>
      <div
        id="ModalSimularDesconto_PercentualDesconto_Valor"
        className={
          validado && formik.errors.PercentualDesconto != undefined
            ? estiloModalSimularDesconto.inputErro
            : ""
        }
      >
        <InputNumerico
          onValorModificado={(valorModificado) => {
            formik.setFieldValue("PercentualDesconto", valorModificado);
            valorModificado != props.dadosSimularDesconto.PercentualDesconto && (
              formik.setFieldValue("PrecoProduto", null),
              props.onManterDadosAlteradoParaCalcular()
            );
          }}
          id="ModalSimularDesconto_PercentualDesconto_input"
          disabled={props.item.BloqueiaUsuarioDarDescontoUnitarioOrcamento} // 431591
          autoFocus
          valor={formik.values.PercentualDesconto}
          style={
            props.dadosSimularDesconto?.DescontoPendente ||
            props.dadosSimularDesconto?.PendenciaDescontoSobreOferta
              ? { color: "#f00" }
              : {}
          }
        />
      </div>
    </>
  ), [formik.values.PercentualDesconto, validado, formik.errors.PercentualDesconto, props.item.BloqueiaUsuarioDarDescontoUnitarioOrcamento, props.dadosSimularDesconto]);

  const percentualBonificacaoMaximaAvancada = useMemo(() => {
    const percentualBonificacaoMaxima = (
      <>
        <label id="ModalSimularDesconto_PercentualBonificacaoMaximaAvancada">Bonificação Máxima (%)</label>
        <div id="ModalSimularDesconto_PercentualBonificacaoMaximaAvancada_Valor">
          {globalMU.formatarValorNumerico(
            props.item?.PercentualBonificacaoMaximaAvancada,
            2,
            false
          )}
        </div>
      </>
    );

    const percentualBonificacaoInput = (
      <div key="percentualBonificacaoInput">
        <label id="ModalSimularDesconto_PercentualBonificacao">Bonificação (%)</label>
        <div
          id="ModalSimularDesconto_PercentualBonificacao_Valor"
          className={
            validado && formik.errors.PercentualBonificacao != undefined
              ? estiloModalSimularDesconto.inputErro
              : ""
          }
        >
          <InputNumerico
            id="ModalSimularDesconto_Input_PercentualBonificacaoMaximaAvancada"
            onValorModificado={(valorModificado) => {
              formik.setFieldValue("PercentualBonificacao", valorModificado);
              valorModificado != props.dadosSimularDesconto.PercentualBonificacao && (
                formik.setFieldValue("PrecoProduto", null),
                props.onManterDadosAlteradoParaCalcular()
              );
            }}
            disabled={props.item.BloqueiaUsuarioDarDescontoUnitarioOrcamento} // 431591
            valor={formik.values.PercentualBonificacao}
            style={props.item?.BonificacaoPendente ? { color: "#f00" } : {}}
          />
        </div>
      </div>
    );

    return [percentualBonificacaoMaxima, percentualBonificacaoInput];
  }, [formik.values.PercentualBonificacao, validado, formik.errors.PercentualBonificacao, props.item, props.dadosSimularDesconto]);

  const precoFinal = useMemo(() => (
    <>
      <label 
        id="ModalSimularDesconto_precoFinal"
        title="Veja parâmentro: Permite alterar o preço do produto para um valor maior que o preço de venda no orçamento?"
      >Preço Final</label>
      <div
        id="ModalSimularDesconto_precoFinal_Valor"
        className={
          validado && formik.errors.PrecoProduto != undefined
            ? estiloModalSimularDesconto.inputErro
            : ""
        }
      >
        <InputNumerico
          onValorModificado={(valorModificado) => {

            formik.setFieldValue("PrecoProduto", valorModificado);
            valorModificado != props.dadosSimularDesconto.Preco && (
              formik.setFieldValue("PercentualDesconto", null),
              formik.setFieldValue("PercentualBonificacao", null)
            ),
            props.onManterDadosAlteradoParaCalcular();
          }}
          disabled={props.item.BloqueiaUsuarioDarDescontoUnitarioOrcamento} // 431591
          valor={formik.values?.PrecoProduto}
          numeroCasasDecimais={props.numeroCasasDecimaisPreco}
          id="ModalSimularDesconto_Input_PrecoProduto"
        />
      </div>
    </>
  ), [formik.values.PrecoProduto, validado, formik.errors.PrecoProduto, props.item.BloqueiaUsuarioDarDescontoUnitarioOrcamento, props.dadosSimularDesconto, props.numeroCasasDecimaisPreco]);

  const botaoOk = useMemo(() => (
    <button
      key="botaoOk"
      className={estiloModalSimularDesconto.botao}
      id="ModalSimularDesconto_Botao_Aplicar"
      disabled={ (
          props.somenteLeitura 
          || (!props.descontoCalculado && !props.permitirAlterarPrecoParaMaior)
          || (!props.descontoCalculado && props.permitirAlterarPrecoParaMaior 
                          && ( formik.values.PrecoProduto == null 
                                || ( (formik.values.PrecoProduto ?? 0) - (formik.values.ValorNaoIncideDesconto ?? 0)) 
                                    <= formik.values.PrecoUnitarioTabela)
            )
          )
      } // 433081 - 260814 e 278816
      onClick={async () => {
        const erros = await formik.validateForm(formik.values);
        if (Object.keys(erros).length > 0) {
          props.onErrorValidacao(erros);
        }
        else if (props.permitirAlterarPrecoParaMaior && ((formik.values.PrecoProduto ?? 0) - (formik.values.ValorNaoIncideDesconto ?? 0)) > formik.values.PrecoUnitarioTabela) 
        { // 462697
            props.onAumentarPreco(formik.values.PrecoProduto) // 462697
        }
        else  {
          props.onAplicar();
        }
        setValidado(true);
      }}
    >
      Aplicar
    </button>
  ), [props.descontoCalculado, props.somenteLeitura, formik.values]);

  const botaoCalcular = useMemo(() => (
    <button
      key="botaoCalcular"
      disabled={(( props.permitirAlterarPrecoParaMaior && ((formik.values.PrecoProduto ?? 0) - (formik.values.ValorNaoIncideDesconto ?? 0)) > formik.values.PrecoUnitarioTabela ))} // 433081 - 260814 e 278816
      className={estiloModalSimularDesconto.botao}
      id="ModalSimularDesconto_Botao_Calcular"
      onClick={() => {
        props.onSimular({
          PercentualDesconto: formik.values.PercentualDesconto,
          PercentualBonificacao: formik.values.PercentualBonificacao,
          PreservaDesconto: formik.values.PreservaDesconto,
          Preco: formik.values.PrecoProduto,
          PreservaDescontoModificadoManualmente: preservaDescontoModificadoManualmente
        });
      }}
    >
      Calcular
    </button>
  ), [formik.values, preservaDescontoModificadoManualmente, props.somenteLeitura]);

  const botaoCancelar = useMemo(() => (
    <button
      key="botaoCancelar"
      className={estiloModalSimularDesconto.botao}
      id="ModalSimularDesconto_Botao_Cancelar"
      onClick={() => props.onCancelar()}
    >
      {props.item.BloqueiaUsuarioDarDescontoUnitarioOrcamento // 431591
        ? "Fechar"
        : "Cancelar"}
    </button>
  ), [props.item.BloqueiaUsuarioDarDescontoUnitarioOrcamento]);

  const preservarDesconto = useMemo(() => (
    <>
      <label>Preservar Desconto</label>
      <input
        type="checkbox"
        checked={formik.values.PreservaDesconto ?? false}
        name="PreservaDesconto"
        id="PreservaDesconto"
        onChange={(e) => {
          formik.handleChange(e);
          setPreservaDescontoModificadoManualmente(true);
        }}
      />
    </>
  ), [formik.values.PreservaDesconto]);

  return (
    <Dialog
      open={true}
      scroll={"paper"}
      className={estiloModalSimularDesconto.dialogModalSimularDesconto}
      id="ModalSimularDesconto"
      PaperComponent={PaperArrastavel}
    >
      <div className={estiloModalSimularDesconto.titulo}
        id="ModalSimularDesconto_Titulo"
        data-arrastar-dialog
      >
        <h4 style={{ fontWeight: 700 }}
          id="ModalSimularDesconto_Titulo_Texto"
        >Simulação de Desconto</h4>
        <div>
          <a className={estiloModalSimularDesconto.exit}
            id="ModalSimularDesconto_Titulo_BotaoFechar"
          >
            <FontAwesomeIcon icon={faTimes} color={"#fff"} onClick={() => props.onCancelar()} />
          </a>
        </div>
      </div>
      <DialogContent style={{ padding: "15px" }}
        id="ModalSimularDesconto_DialogContent"
      >
        <div className={estiloFormulario.formulario}
          id="ModalSimularDesconto_Formulario"
        >
          {descricaoProduto}
          {precoDeLista}
          {percentualDescontoMaximo}
          {percentualDesconto}
          {props.exibirCheckboxPreservarDesconto && preservarDesconto}
          {props.exibirDescontoMaximoBonificacaoAvancados && percentualBonificacaoMaximaAvancada}
          {precoFinal}
        </div>
        <DialogActions style={{ padding: "15px" }}>
          {!props.item.BloqueiaUsuarioDarDescontoUnitarioOrcamento // 431591
            && botaoCalcular}
          {!props.somenteLeitura && !props.item.BloqueiaUsuarioDarDescontoUnitarioOrcamento // 431591
            && botaoOk}
          {botaoCancelar}
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};